import { createAction } from 'typesafe-actions';

import { IJsonQuery } from 'shared/models/JsonQuery';

export const setSaveSearchJsonQuery = createAction('saveSearch/set_json_query')<IJsonQuery>();
